import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import ClipLoader from "react-spinners/ClipLoader";
import Phonecase from './Phonecase/Phonecase';
import { Box, Button, FormControl, InputAdornment, Menu, MenuItem, Stack, TextField, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import Sidebar from '../Sidebar/Sidebar';
import { useGetAllBrandsQuery, useGetAllColorsQuery, useGetAllActivePhonecasesQuery, useGetAllStoragesQuery, useGetAllInactivePhonecasesQuery } from '../../../features/fullApi';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import Error500 from '../../ErrorPages/Error500';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import '../../../App.css'
import '../autocomplete.css'
import PaginationComp from '../Pagination/PaginationComp';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const Container = styled.div`
   margin-top: 20px;
`;

const MobileContainer = styled.div`
  margin-top: 180px;
`;


const Phonecases = () => {
  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }
  window.scrollTo(0, 0);

  useEffect(() => {
    if(!user) {
    }

  }, [user])

  const params = useParams()

  //#################################
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //#################################

  const {data, error, isLoading} = useGetAllActivePhonecasesQuery();
  const {data: dataInactive, error: errorInactive, isLoading: isLoadingInactive} = useGetAllInactivePhonecasesQuery();

  const [resetFilter, setResetFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(params.page - 1)

  //!constructing the brands/storages/colors key value array with id:name
  const {data:brands, errorBrands, isLoadingBrands} = useGetAllBrandsQuery();
  let brandsArr = []
  brands?.map(brand => {
    brandsArr[brand._id] = brand.brandName
  })

  const {data:storages, errorStorages, isLoadingStorages} = useGetAllStoragesQuery();
  let storagesArr = []
  storages?.map(storage => {
    storagesArr[storage._id] = storage.storageName
  })

  const {data:colors, errorColors, isLoadingColors} = useGetAllColorsQuery();
  let colorsArr = []
  colors?.map(color => {
    colorsArr[color._id] = color.colorName
  })
  //!constructing the brands key value array with id:name

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  let phonecasesPerPage

  if(isXs || isSm) {
    phonecasesPerPage = 16
  } else if(isMd) {
    phonecasesPerPage = 24
  } else {
    phonecasesPerPage = 32
  }

  const pagesVisited = pageNumber * phonecasesPerPage
  const [act, setAct] = useState(true)

  useEffect(() => {
    navigate(`/phonecases/${pageNumber + 1}`)
    sessionStorage.setItem('pageNumber', pageNumber)
    if(filtered) {
    setDisplayPhonecases(filteredPhonecases?.slice(pagesVisited, pagesVisited + phonecasesPerPage))
    } else {
      setDisplayPhonecases(data?.slice(pagesVisited, pagesVisited + phonecasesPerPage))
    }
  }, [pageNumber])





  const [displayPhonecases, setDisplayPhonecases] =  useState([])
  
  const [pageCount, setPageCount] = useState(0)

  useEffect(() => {
    if(!isLoading && !isLoadingInactive) {
      if(!act) {
        setDisplayPhonecases(dataInactive?.slice(pagesVisited, pagesVisited + phonecasesPerPage))
        setPageCount(Math.ceil(dataInactive?.length / phonecasesPerPage))
      } else {
        setDisplayPhonecases(data?.slice(pagesVisited, pagesVisited + phonecasesPerPage))
        setPageCount(Math.ceil(data?.length / phonecasesPerPage))
      }
    }
  }, [isLoading, isLoadingInactive, act, data, dataInactive])

  console.log("DISPLAY PHONECASES", displayPhonecases)

  const [filteredPhonecases, setFilteredPhonecases] = useState([])


  const [hitted, setHitted] = useState(false)
  const [filtered, setFiltered] = useState(false)

  const handleFilterProducts = async (filteredPhonecases) => {
      setFiltered(true)
      setPageCount(Math.ceil(filteredPhonecases?.length / phonecasesPerPage))
      setDisplayPhonecases(filteredPhonecases?.slice(pagesVisited, pagesVisited + phonecasesPerPage))
      setFilteredPhonecases(filteredPhonecases)
  }

  const clearSearch = () => {
    const resetSearch = async () => {
     setSearch("")
    };

    resetSearch()
  }

  const [showSidebar, setShowSidebar] = useState(false)

  const navigate = useNavigate()

  const handleStatus = (event, newStatus) => {
    console.log("new status", newStatus)
    if (newStatus !== null) {
      if(newStatus === "Active") {
        setAct(true)
      } else {
        setAct(false)
      }
    }
  };

  const StackSelect = () => (
    <Stack direction="row" style={{display: 'flex', justifyContent: 'center', alignCenter: 'center', marginBottom:'20px'}}>
    <ToggleButtonGroup
      value={act}
      exclusive
      onChange={handleStatus}
      aria-label="text alignment"
    >
      <ToggleButton value="Active">
        <CheckIcon style={{color: 'green'}} />
      </ToggleButton>
      <ToggleButton value="Inactive">
        <CloseIcon style={{color: 'red'}}/>
      </ToggleButton>
    </ToggleButtonGroup>
  </Stack>
  )


  const renderMobilePhonecases = () => (
    <>
    <div>
      {act ? (
      <div>
        {isLoadingInactive ? (
          <div className="flexCenter" style={{height: 'calc(100vh - 130px)'}}>
            <ClipLoader
              color="#93032E"
              loading={isLoadingInactive}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>      
        ) : errorInactive ? (<Error500></Error500>)
        :(<>
          <MobileContainer>
            <div id={showSidebar ? "sidebarShow" : "hideSidebar"}>{user?._id &&
                <Sidebar type={"phonecase"} handleFilterProducts={handleFilterProducts} showSidebar={showSidebar} setShowSidebar={setShowSidebar} resetFilter={resetFilter}/>}
            </div>
            <MobileContainer>
            <div style={{position: 'fixed', top: '0', zIndex:"200", marginTop: '110px', padding:'10px 0', backgroundColor:"#fff", display: 'flex', justifyContent: 'space-around', width: '100%'}}>
              <Button style={{width: '150px', fontSize: "12px"}} color="primary" variant="contained" onClick={() => setShowSidebar(true)}>Show filters</Button>
              {user?.isAdmin &&
              (
              <>
                <Button variant="contained" color="secondary" style={{width: '150px', fontSize: "12px"}} onClick={() => navigate("/phonecase/create")}>Add Phonecase</Button>
              </>
              )
              }
            </div>
          </MobileContainer>

          </MobileContainer>

            <MobileContainer>
              <h3 style={{textAlign: 'center'}}>Phonecases</h3>
              {user?.isAdmin && <StackSelect/> }
              <Grid container rowSpacing={2} columnSpacing={1} className="gridClass">
                {(filteredPhonecases.length > 0 ) &&
                <>
                  {filteredPhonecases.filter((phonecase) => {
                    return search.toLowerCase() === '' ? phonecase : phonecase.title.toLowerCase().includes(search)
                  }).map((phonecase) => (
                    <Grid key={phonecase._id} item xs={6} lg={4} xl={2}>
                      <Phonecase phonecase={phonecase}/>
                    </Grid>
                  ))}
                </>
                }
                {!hitted &&
                <>
                  {search ? (
                  <>
                    {dataInactive?.map((phonecase) => (
                        <Grid key={phonecase._id} item xs={6} lg={3} xl={2}>
                          <Phonecase phonecase={phonecase}/>
                        </Grid>
                      ))}
                  </>
                  ) : (
                    <>
                    {displayPhonecases?.map((phonecase) => (
                      <Grid key={phonecase._id} item xs={6} lg={3} xl={2}>
                        <Phonecase phonecase={phonecase}/>
                      </Grid>
                    ))}
                  </>
                  )
                  }
                  <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
                </>}
                <div>
                  {(filteredPhonecases.length === 0 && hitted) && 
                  <h3>
                    No phonecases found for your search
                  </h3>}
                </div>
              </Grid>
            </MobileContainer>
          </>
        )
      }
      </div>) : (
              <div>
              {isLoading ? (
                <div className="flexCenter" style={{height: 'calc(100vh - 130px)'}}>
                  <ClipLoader
                    color="#93032E"
                    loading={isLoading}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </div>      
              ) : error ? (<Error500></Error500>)
              :(<>
                <MobileContainer>
                  <div id={showSidebar ? "sidebarShow" : "hideSidebar"}>{user?._id &&
                      <Sidebar handleFilterProducts={handleFilterProducts} showSidebar={showSidebar} setShowSidebar={setShowSidebar} resetFilter={resetFilter}/>}
                  </div>
                  <MobileContainer>
                  <div style={{position: 'fixed', top: '0', zIndex:"200", backgroundColor:"#fff", marginTop: '110px', padding:'10px 0', display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                    <Button style={{width: '150px', fontSize: "12px"}} color="primary" variant="contained" onClick={() => setShowSidebar(true)}>Show filters</Button>
                    {user?.isAdmin &&
                    (
                    <Button variant="contained" color="secondary" style={{width: '150px', fontSize: "12px"}} onClick={() => navigate("/phonecase/create")}>Add Phonecase</Button>
                    )
                    }
                  </div>
                </MobileContainer>
      
                </MobileContainer>
      
                  <MobileContainer>
                    <h3 style={{textAlign: 'center'}}>Phonecases</h3>
                    {user?.isAdmin && <StackSelect/> }
                    <Grid container rowSpacing={2} columnSpacing={1} className="gridClass">
                      {(filteredPhonecases.length > 0 ) &&
                      <>
                        {filteredPhonecases.map((phonecase) => (
                          <Grid key={phonecase._id} item xs={6} lg={3} xl={2}>
                            <Phonecase phonecase={phonecase}/>
                          </Grid>
                        ))}
                      </>}
                      {!hitted &&
                      <>
                        {search ? (
                        <>
                          {data?.filter((phonecase) => {
                              return search.toLowerCase() === '' ? phonecase : phonecase.title.toLowerCase().includes(search)
                            }).map((phonecase) => (
                              <Grid key={phonecase._id} item xs={6} lg={3} xl={2}>
                                <Phonecase phonecase={phonecase}/>
                              </Grid>
                            ))}
                        </>
                        ) : (
                          <>
                          {displayPhonecases?.filter((phonecase) => {
                            return search.toLowerCase() === '' ? phonecase : phonecase.title.toLowerCase().includes(search)
                          }).map((phonecase) => (
                            <Grid key={phonecase._id} item xs={6} lg={3} xl={2}>
                              <Phonecase phonecase={phonecase}/>
                            </Grid>
                          ))}
                      </>
                        )
                        }
                        <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
                      </>}
                      <div>
                        {(filteredPhonecases.length === 0 && hitted) && 
                        <h3>
                          No phonecases found for your search
                        </h3>}
                      </div>
                    </Grid>
                  </MobileContainer>
                </>
              )
            }
            </div>
      )}
    </div>
    </>
  )

  const renderTabletPhonecases = () => (
    <div>
    {isLoading ? (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    ) 
    : error ? (<Error500></Error500>)
    :(
      <>
      <Container style={{display: 'flex', justifyContent: 'space-between'}}>
        <div style={{marginTop: '64px'}}>{user?._id &&
            <Sidebar handleFilterProducts={handleFilterProducts} resetFilter={resetFilter}/>}
        </div>
        <div id="filterContainer">
          <TextField variant="outlined" size="small" placeholder="search phonecase by name" onChange={(e) => setSearch(e.target.value)} value={search} id="searchInput" style={{backgroundColor: '#fff'}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {
                    search === "" ? (
                      <SearchIcon className="iconClass" />
                    ) : (<ClearIcon className="iconClass" onClick={clearSearch}/>)
                  }
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div>
          {user?.isAdmin &&
                (
                    <div>
                    <Button
                      id="demo-positioned-button"
                      aria-controls={open ? 'demo-positioned-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                    >
                      Dashboard
                    </Button>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <MenuItem onClick={handleClose}>Profile</MenuItem>
                      <MenuItem onClick={handleClose}>My account</MenuItem>
                      <MenuItem onClick={handleClose}>Logout</MenuItem>
                    </Menu>
                  </div>
                )
          }
        </div>
      </Container>

        <Container>
          <Grid container justify="center" spacing={10} className="gridClass">
            {(filteredPhonecases?.length > 0 ) &&
            <>
              {filteredPhonecases.map((phonecase) => (
                <Grid key={phonecase._id} item>
                  <Phonecase phonecase={phonecase}/>
                </Grid>
              ))}
            </>}
            {!hitted &&
            <> 
                {displayPhonecases?.filter((phonecase) => {
                   return search.toLowerCase() === '' ? phonecase : phonecase.title.toLowerCase().includes(search)
                 }).map((phonecase) => (
                   <Grid key={phonecase._id} item>
                     <Phonecase phonecase={phonecase}/>
                   </Grid>
                 ))}
             </>    
            }
         
         <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
          </Grid>
        </Container>
      </>
    )
  }
  </div>
  )

  const renderDesktopPhonecases = () => (
    <>
    <div style={{width: '1200px', margin: '0 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
    <div>
    {user?.isAdmin &&
              (
              <div style={{display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center', marginTop:'50px'}}>
                <div>
                  <Button variant="contained" style={{width: '200px', marginBottom: '30px'}} onClick={() => navigate("/phonecase/create")}>Create Phonecase</Button>
                </div>
                <div>
                  <StackSelect/>
                </div>
              </div>
            )
    }
    </div>
    {(isLoading) ? (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    ) 
    : (error) ? (<Error500></Error500>)
    :(
      <>
        <Container style={{display: 'flex', flexDirection:'column'}}>
          <div style={{marginBottom:'50px'}}>
            <h1 style={{textAlign:'center'}}>Phonecases</h1>
          </div>
          <div style={{display:'flex'}}>
          <Sidebar type={"phonecase"} handleFilterProducts={handleFilterProducts} resetFilter={resetFilter}/>

          <Box sx={{ flexGrow: 1 }}>
          <Grid container>
              <>
              <>
                 {displayPhonecases?.map((phonecase) => (
                  <Grid key={phonecase._id} item>
                    <Phonecase phonecase={phonecase}/>
                  </Grid>
                ))}
              </>
              
              {/* <>
                {filteredPhonecases.map((phonecase) => (
                  <Grid key={phonecase._id} item>
                    <Phonecase phonecase={phonecase}/>
                  </Grid>
                ))}
              </>   */}

     
        <Container style={{width:'100%'}}>
        {pageCount !== 1 &&
          <PaginationComp 
          pageCount={pageCount} 
          paramsPage={params.page} 
          pageNumber={pageNumber} 
          setPageNumber={setPageNumber}/>
        }
        </Container>
              </>
          </Grid>
        </Box>
          </div>
        </Container>

   
      </>
    )
  }
  </div>
  </>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobilePhonecases() : 
        (isSm) ? renderMobilePhonecases() :
        (isMd) ? renderTabletPhonecases() :
        renderDesktopPhonecases()
      }
    </div>
  );
};

export default Phonecases;